/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */ (function($) {
    /*>>core*/ /**
     *
     * Magnific Popup Core JS file
     *
     */ /**
     * Private static constants
     */ var CLOSE_EVENT = 'Close', BEFORE_CLOSE_EVENT = 'BeforeClose', AFTER_CLOSE_EVENT = 'AfterClose', BEFORE_APPEND_EVENT = 'BeforeAppend', MARKUP_PARSE_EVENT = 'MarkupParse', OPEN_EVENT = 'Open', CHANGE_EVENT = 'Change', NS = 'mfp', EVENT_NS = '.' + NS, READY_CLASS = 'mfp-ready', REMOVING_CLASS = 'mfp-removing', PREVENT_CLOSE_CLASS = 'mfp-prevent-close';
    /**
     * Private vars
     */ /*jshint -W079 */ var mfp, MagnificPopup = function() {}, _isJQ = !!window.jQuery, _prevStatus, _window = $(window), _document, _prevContentType, _wrapClasses, _currPopupType;
    /**
     * Private functions
     */ var _mfpOn = function(name, f) {
        mfp.ev.on(NS + name + EVENT_NS, f);
    }, _getEl = function(className, appendTo, html, raw) {
        var el = document.createElement('div');
        el.className = 'mfp-' + className;
        if (html) el.innerHTML = html;
        if (!raw) {
            el = $(el);
            if (appendTo) el.appendTo(appendTo);
        } else if (appendTo) appendTo.appendChild(el);
        return el;
    }, _mfpTrigger = function(e, data) {
        mfp.ev.triggerHandler(NS + e, data);
        if (mfp.st.callbacks) {
            // converts "mfpEventName" to "eventName" callback and triggers it if it's present
            e = e.charAt(0).toLowerCase() + e.slice(1);
            if (mfp.st.callbacks[e]) mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [
                data
            ]);
        }
    }, _getCloseBtn = function(type) {
        if (type !== _currPopupType || !mfp.currTemplate.closeBtn) {
            mfp.currTemplate.closeBtn = $(mfp.st.closeMarkup.replace('%title%', mfp.st.tClose));
            _currPopupType = type;
        }
        return mfp.currTemplate.closeBtn;
    }, // Initialize Magnific Popup only when called at least once
    _checkInstance = function() {
        if (!$.magnificPopup.instance) {
            /*jshint -W020 */ mfp = new MagnificPopup();
            mfp.init();
            $.magnificPopup.instance = mfp;
        }
    }, // CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
    supportsTransitions = function() {
        var s = document.createElement('p').style, v = [
            'ms',
            'O',
            'Moz',
            'Webkit'
        ]; // 'v' for vendor
        if (s['transition'] !== undefined) return true;
        while(v.length){
            if (v.pop() + 'Transition' in s) return true;
        }
        return false;
    };
    /**
     * Public functions
     */ MagnificPopup.prototype = {
        constructor: MagnificPopup,
        /**
         * Initializes Magnific Popup plugin.
         * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
         */ init: function() {
            var appVersion = navigator.appVersion;
            mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
            mfp.isAndroid = /android/gi.test(appVersion);
            mfp.isIOS = /iphone|ipad|ipod/gi.test(appVersion);
            mfp.supportsTransition = supportsTransitions();
            // We disable fixed positioned lightbox on devices that don't handle it nicely.
            // If you know a better way of detecting this - let me know.
            mfp.probablyMobile = mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent);
            _document = $(document);
            mfp.popupsCache = {};
        },
        /**
         * Opens popup
         * @param  data [description]
         */ open: function(data) {
            var i;
            if (data.isObj === false) {
                // convert jQuery collection to array to avoid conflicts later
                mfp.items = data.items.toArray();
                mfp.index = 0;
                var items = data.items, item;
                for(i = 0; i < items.length; i++){
                    item = items[i];
                    if (item.parsed) item = item.el[0];
                    if (item === data.el[0]) {
                        mfp.index = i;
                        break;
                    }
                }
            } else {
                mfp.items = $.isArray(data.items) ? data.items : [
                    data.items
                ];
                mfp.index = data.index || 0;
            }
            // if popup is already opened - we just update the content
            if (mfp.isOpen) {
                mfp.updateItemHTML();
                return;
            }
            mfp.types = [];
            _wrapClasses = '';
            if (data.mainEl && data.mainEl.length) mfp.ev = data.mainEl.eq(0);
            else mfp.ev = _document;
            if (data.key) {
                if (!mfp.popupsCache[data.key]) mfp.popupsCache[data.key] = {};
                mfp.currTemplate = mfp.popupsCache[data.key];
            } else mfp.currTemplate = {};
            mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data);
            mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;
            if (mfp.st.modal) {
                mfp.st.closeOnContentClick = false;
                mfp.st.closeOnBgClick = false;
                mfp.st.showCloseBtn = false;
                mfp.st.enableEscapeKey = false;
            }
            // Building markup
            // main containers are created only once
            if (!mfp.bgOverlay) {
                // Dark overlay
                mfp.bgOverlay = _getEl('bg').on('click' + EVENT_NS, function() {
                    mfp.close();
                });
                mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click' + EVENT_NS, function(e) {
                    if (mfp._checkIfClose(e.target)) mfp.close();
                });
                mfp.container = _getEl('container', mfp.wrap);
            }
            mfp.contentContainer = _getEl('content');
            if (mfp.st.preloader) mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
            // Initializing modules
            var modules = $.magnificPopup.modules;
            for(i = 0; i < modules.length; i++){
                var n = modules[i];
                n = n.charAt(0).toUpperCase() + n.slice(1);
                mfp['init' + n].call(mfp);
            }
            _mfpTrigger('BeforeOpen');
            if (mfp.st.showCloseBtn) {
                // Close button
                if (!mfp.st.closeBtnInside) mfp.wrap.append(_getCloseBtn());
                else {
                    _mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
                        values.close_replaceWith = _getCloseBtn(item.type);
                    });
                    _wrapClasses += ' mfp-close-btn-in';
                }
            }
            if (mfp.st.alignTop) _wrapClasses += ' mfp-align-top';
            if (mfp.fixedContentPos) mfp.wrap.css({
                overflow: mfp.st.overflowY,
                overflowX: 'hidden',
                overflowY: mfp.st.overflowY
            });
            else mfp.wrap.css({
                top: _window.scrollTop(),
                position: 'absolute'
            });
            if (mfp.st.fixedBgPos === false || mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) mfp.bgOverlay.css({
                height: _document.height(),
                position: 'absolute'
            });
            if (mfp.st.enableEscapeKey) // Close on ESC key
            _document.on('keyup' + EVENT_NS, function(e) {
                if (e.keyCode === 27) mfp.close();
            });
            _window.on('resize' + EVENT_NS, function() {
                mfp.updateSize();
            });
            if (!mfp.st.closeOnContentClick) _wrapClasses += ' mfp-auto-cursor';
            if (_wrapClasses) mfp.wrap.addClass(_wrapClasses);
            // this triggers recalculation of layout, so we get it once to not to trigger twice
            var windowHeight = mfp.wH = _window.height();
            var windowStyles = {};
            if (mfp.fixedContentPos) {
                if (mfp._hasScrollBar(windowHeight)) {
                    var s = mfp._getScrollbarSize();
                    if (s) windowStyles.marginRight = s;
                }
            }
            if (mfp.fixedContentPos) {
                if (!mfp.isIE7) windowStyles.overflow = 'hidden';
                else // ie7 double-scroll bug
                $('body, html').css('overflow', 'hidden');
            }
            var classesToadd = mfp.st.mainClass;
            if (mfp.isIE7) classesToadd += ' mfp-ie7';
            if (classesToadd) mfp._addClassToMFP(classesToadd);
            // add content
            mfp.updateItemHTML();
            _mfpTrigger('BuildControls');
            // remove scrollbar, add margin e.t.c
            $('html').css(windowStyles);
            // add everything to DOM
            mfp.bgOverlay.add(mfp.wrap).prependTo(mfp.st.prependTo || $(document.body));
            // Save last focused element
            mfp._lastFocusedEl = document.activeElement;
            // Wait for next cycle to allow CSS transition
            setTimeout(function() {
                if (mfp.content) {
                    mfp._addClassToMFP(READY_CLASS);
                    mfp._setFocus();
                } else // if content is not defined (not loaded e.t.c) we add class only for BG
                mfp.bgOverlay.addClass(READY_CLASS);
                // Trap the focus in popup
                _document.on('focusin' + EVENT_NS, mfp._onFocusIn);
            }, 16);
            mfp.isOpen = true;
            mfp.updateSize(windowHeight);
            _mfpTrigger(OPEN_EVENT);
            return data;
        },
        /**
         * Closes the popup
         */ close: function() {
            if (!mfp.isOpen) return;
            _mfpTrigger(BEFORE_CLOSE_EVENT);
            mfp.isOpen = false;
            // for CSS3 animation
            if (mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition) {
                mfp._addClassToMFP(REMOVING_CLASS);
                setTimeout(function() {
                    mfp._close();
                }, mfp.st.removalDelay);
            } else mfp._close();
        },
        /**
         * Helper for close() function
         */ _close: function() {
            _mfpTrigger(CLOSE_EVENT);
            var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';
            mfp.bgOverlay.detach();
            mfp.wrap.detach();
            mfp.container.empty();
            if (mfp.st.mainClass) classesToRemove += mfp.st.mainClass + ' ';
            mfp._removeClassFromMFP(classesToRemove);
            if (mfp.fixedContentPos) {
                var windowStyles = {
                    marginRight: ''
                };
                if (mfp.isIE7) $('body, html').css('overflow', '');
                else windowStyles.overflow = '';
                $('html').css(windowStyles);
            }
            _document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
            mfp.ev.off(EVENT_NS);
            // clean up DOM elements that aren't removed
            mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
            mfp.bgOverlay.attr('class', 'mfp-bg');
            mfp.container.attr('class', 'mfp-container');
            // remove close button from target element
            if (mfp.st.showCloseBtn && (!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
                if (mfp.currTemplate.closeBtn) mfp.currTemplate.closeBtn.detach();
            }
            if (mfp.st.autoFocusLast && mfp._lastFocusedEl) $(mfp._lastFocusedEl).focus(); // put tab focus back
            mfp.currItem = null;
            mfp.content = null;
            mfp.currTemplate = null;
            mfp.prevHeight = 0;
            _mfpTrigger(AFTER_CLOSE_EVENT);
        },
        updateSize: function(winHeight) {
            if (mfp.isIOS) {
                // fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
                var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
                var height = window.innerHeight * zoomLevel;
                mfp.wrap.css('height', height);
                mfp.wH = height;
            } else mfp.wH = winHeight || _window.height();
            // Fixes #84: popup incorrectly positioned with position:relative on body
            if (!mfp.fixedContentPos) mfp.wrap.css('height', mfp.wH);
            _mfpTrigger('Resize');
        },
        /**
         * Set content of popup based on current index
         */ updateItemHTML: function() {
            var item = mfp.items[mfp.index];
            // Detach and perform modifications
            mfp.contentContainer.detach();
            if (mfp.content) mfp.content.detach();
            if (!item.parsed) item = mfp.parseEl(mfp.index);
            var type = item.type;
            _mfpTrigger('BeforeChange', [
                mfp.currItem ? mfp.currItem.type : '',
                type
            ]);
            // BeforeChange event works like so:
            // _mfpOn('BeforeChange', function(e, prevType, newType) { });
            mfp.currItem = item;
            if (!mfp.currTemplate[type]) {
                var markup = mfp.st[type] ? mfp.st[type].markup : false;
                // allows to modify markup
                _mfpTrigger('FirstMarkupParse', markup);
                if (markup) mfp.currTemplate[type] = $(markup);
                else // if there is no markup found we just define that template is parsed
                mfp.currTemplate[type] = true;
            }
            if (_prevContentType && _prevContentType !== item.type) mfp.container.removeClass('mfp-' + _prevContentType + '-holder');
            var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
            mfp.appendContent(newContent, type);
            item.preloaded = true;
            _mfpTrigger(CHANGE_EVENT, item);
            _prevContentType = item.type;
            // Append container back after its content changed
            mfp.container.prepend(mfp.contentContainer);
            _mfpTrigger('AfterChange');
        },
        /**
         * Set HTML content of popup
         */ appendContent: function(newContent, type) {
            mfp.content = newContent;
            if (newContent) {
                if (mfp.st.showCloseBtn && mfp.st.closeBtnInside && mfp.currTemplate[type] === true) // if there is no markup, we just append close button element inside
                {
                    if (!mfp.content.find('.mfp-close').length) mfp.content.append(_getCloseBtn());
                } else mfp.content = newContent;
            } else mfp.content = '';
            _mfpTrigger(BEFORE_APPEND_EVENT);
            mfp.container.addClass('mfp-' + type + '-holder');
            mfp.contentContainer.append(mfp.content);
        },
        /**
         * Creates Magnific Popup data object based on given data
         * @param  {int} index Index of item to parse
         */ parseEl: function(index) {
            var item = mfp.items[index], type;
            if (item.tagName) item = {
                el: $(item)
            };
            else {
                type = item.type;
                item = {
                    data: item,
                    src: item.src
                };
            }
            if (item.el) {
                var types = mfp.types;
                // check for 'mfp-TYPE' class
                for(var i = 0; i < types.length; i++)if (item.el.hasClass('mfp-' + types[i])) {
                    type = types[i];
                    break;
                }
                item.src = item.el.attr('data-mfp-src');
                if (!item.src) item.src = item.el.attr('href');
            }
            item.type = type || mfp.st.type || 'inline';
            item.index = index;
            item.parsed = true;
            mfp.items[index] = item;
            _mfpTrigger('ElementParse', item);
            return mfp.items[index];
        },
        /**
         * Initializes single popup or a group of popups
         */ addGroup: function(el, options) {
            var eHandler = function(e) {
                e.mfpEl = this;
                mfp._openClick(e, el, options);
            };
            if (!options) options = {};
            var eName = 'click.magnificPopup';
            options.mainEl = el;
            if (options.items) {
                options.isObj = true;
                el.off(eName).on(eName, eHandler);
            } else {
                options.isObj = false;
                if (options.delegate) el.off(eName).on(eName, options.delegate, eHandler);
                else {
                    options.items = el;
                    el.off(eName).on(eName, eHandler);
                }
            }
        },
        _openClick: function(e, el, options) {
            var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;
            if (!midClick && (e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey)) return;
            var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;
            if (disableOn) {
                if ($.isFunction(disableOn)) {
                    if (!disableOn.call(mfp)) return true;
                } else {
                    if (_window.width() < disableOn) return true;
                }
            }
            if (e.type) {
                e.preventDefault();
                // This will prevent popup from closing if element is inside and popup is already opened
                if (mfp.isOpen) e.stopPropagation();
            }
            options.el = $(e.mfpEl);
            if (options.delegate) options.items = el.find(options.delegate);
            mfp.open(options);
        },
        /**
         * Updates text on preloader
         */ updateStatus: function(status, text) {
            if (mfp.preloader) {
                if (_prevStatus !== status) mfp.container.removeClass('mfp-s-' + _prevStatus);
                if (!text && status === 'loading') text = mfp.st.tLoading;
                var data = {
                    status: status,
                    text: text
                };
                // allows to modify status
                _mfpTrigger('UpdateStatus', data);
                status = data.status;
                text = data.text;
                mfp.preloader.html(text);
                mfp.preloader.find('a').on('click', function(e) {
                    e.stopImmediatePropagation();
                });
                mfp.container.addClass('mfp-s-' + status);
                _prevStatus = status;
            }
        },
        /*
            "Private" helpers that aren't private at all
         */ // Check to close popup or not
        // "target" is an element that was clicked
        _checkIfClose: function(target) {
            if ($(target).hasClass(PREVENT_CLOSE_CLASS)) return;
            var closeOnContent = mfp.st.closeOnContentClick;
            var closeOnBg = mfp.st.closeOnBgClick;
            if (closeOnContent && closeOnBg) return true;
            else {
                // We close the popup if click is on close button or on preloader. Or if there is no content.
                if (!mfp.content || $(target).hasClass('mfp-close') || mfp.preloader && target === mfp.preloader[0]) return true;
                // if click is outside the content
                if (target !== mfp.content[0] && !$.contains(mfp.content[0], target)) {
                    if (closeOnBg) {
                        // last check, if the clicked element is in DOM, (in case it's removed onclick)
                        if ($.contains(document, target)) return true;
                    }
                } else if (closeOnContent) return true;
            }
            return false;
        },
        _addClassToMFP: function(cName) {
            mfp.bgOverlay.addClass(cName);
            mfp.wrap.addClass(cName);
        },
        _removeClassFromMFP: function(cName) {
            this.bgOverlay.removeClass(cName);
            mfp.wrap.removeClass(cName);
        },
        _hasScrollBar: function(winHeight) {
            return (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height());
        },
        _setFocus: function() {
            (mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
        },
        _onFocusIn: function(e) {
            if (e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target)) {
                mfp._setFocus();
                return false;
            }
        },
        _parseMarkup: function(template, values, item) {
            var arr;
            if (item.data) values = $.extend(item.data, values);
            _mfpTrigger(MARKUP_PARSE_EVENT, [
                template,
                values,
                item
            ]);
            $.each(values, function(key, value) {
                if (value === undefined || value === false) return true;
                arr = key.split('_');
                if (arr.length > 1) {
                    var el = template.find(EVENT_NS + '-' + arr[0]);
                    if (el.length > 0) {
                        var attr = arr[1];
                        if (attr === 'replaceWith') {
                            if (el[0] !== value[0]) el.replaceWith(value);
                        } else if (attr === 'img') {
                            if (el.is('img')) el.attr('src', value);
                            else el.replaceWith($('<img>').attr('src', value).attr('class', el.attr('class')));
                        } else el.attr(arr[1], value);
                    }
                } else template.find(EVENT_NS + '-' + key).html(value);
            });
        },
        _getScrollbarSize: function() {
            // thx David
            if (mfp.scrollbarSize === undefined) {
                var scrollDiv = document.createElement("div");
                scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
                document.body.appendChild(scrollDiv);
                mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
            }
            return mfp.scrollbarSize;
        }
    }; /* MagnificPopup core prototype end */ 
    /**
     * Public static functions
     */ $.magnificPopup = {
        instance: null,
        proto: MagnificPopup.prototype,
        modules: [],
        open: function(options, index) {
            _checkInstance();
            if (!options) options = {};
            else options = $.extend(true, {}, options);
            options.isObj = true;
            options.index = index || 0;
            return this.instance.open(options);
        },
        close: function() {
            return $.magnificPopup.instance && $.magnificPopup.instance.close();
        },
        registerModule: function(name, module) {
            if (module.options) $.magnificPopup.defaults[name] = module.options;
            $.extend(this.proto, module.proto);
            this.modules.push(name);
        },
        defaults: {
            // Info about options is in docs:
            // http://dimsemenov.com/plugins/magnific-popup/documentation.html#options
            disableOn: 0,
            key: null,
            midClick: false,
            mainClass: '',
            preloader: true,
            focus: '',
            closeOnContentClick: false,
            closeOnBgClick: true,
            closeBtnInside: true,
            showCloseBtn: true,
            enableEscapeKey: true,
            modal: false,
            alignTop: false,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: 'auto',
            fixedBgPos: 'auto',
            overflowY: 'auto',
            closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
            tClose: 'Close (Esc)',
            tLoading: 'Loading...',
            autoFocusLast: true
        }
    };
    $.fn.magnificPopup = function(options) {
        _checkInstance();
        var jqEl = $(this);
        // We call some API method of first param is a string
        if (typeof options === "string") {
            if (options === 'open') {
                var items, itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup, index = parseInt(arguments[1], 10) || 0;
                if (itemOpts.items) items = itemOpts.items[index];
                else {
                    items = jqEl;
                    if (itemOpts.delegate) items = items.find(itemOpts.delegate);
                    items = items.eq(index);
                }
                mfp._openClick({
                    mfpEl: items
                }, jqEl, itemOpts);
            } else if (mfp.isOpen) mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
        } else {
            // clone options obj
            options = $.extend(true, {}, options);
            /*
             * As Zepto doesn't support .data() method for objects
             * and it works only in normal browsers
             * we assign "options" object directly to the DOM element. FTW!
             */ if (_isJQ) jqEl.data('magnificPopup', options);
            else jqEl[0].magnificPopup = options;
            mfp.addGroup(jqEl, options);
        }
        return jqEl;
    };
    /*>>core*/ /*>>ajax*/ var AJAX_NS = 'ajax', _ajaxCur, _removeAjaxCursor = function() {
        if (_ajaxCur) $(document.body).removeClass(_ajaxCur);
    }, _destroyAjaxRequest = function() {
        _removeAjaxCursor();
        if (mfp.req) mfp.req.abort();
    };
    $.magnificPopup.registerModule(AJAX_NS, {
        options: {
            settings: null,
            cursor: 'mfp-ajax-cur',
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                mfp.types.push(AJAX_NS);
                _ajaxCur = mfp.st.ajax.cursor;
                _mfpOn(CLOSE_EVENT + '.' + AJAX_NS, _destroyAjaxRequest);
                _mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
            },
            getAjax: function(item) {
                if (_ajaxCur) $(document.body).addClass(_ajaxCur);
                mfp.updateStatus('loading');
                var opts = $.extend({
                    url: item.src,
                    success: function(data, textStatus, jqXHR) {
                        var temp = {
                            data: data,
                            xhr: jqXHR
                        };
                        _mfpTrigger('ParseAjax', temp);
                        mfp.appendContent($(temp.data), AJAX_NS);
                        item.finished = true;
                        _removeAjaxCursor();
                        mfp._setFocus();
                        setTimeout(function() {
                            mfp.wrap.addClass(READY_CLASS);
                        }, 16);
                        mfp.updateStatus('ready');
                        _mfpTrigger('AjaxContentAdded');
                    },
                    error: function() {
                        _removeAjaxCursor();
                        item.finished = item.loadError = true;
                        mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
                    }
                }, mfp.st.ajax.settings);
                mfp.req = $.ajax(opts);
                return '';
            }
        }
    });
    /*>>ajax*/ /*>>image*/ var _imgInterval, _getTitle = function(item) {
        if (item.data && item.data.title !== undefined) return item.data.title;
        var src = mfp.st.image.titleSrc;
        if (src) {
            if ($.isFunction(src)) return src.call(mfp, item);
            else if (item.el) return item.el.attr(src) || '';
        }
        return '';
    };
    $.magnificPopup.registerModule('image', {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: 'mfp-zoom-out-cur',
            titleSrc: 'title',
            verticalFit: true,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var imgSt = mfp.st.image, ns = '.image';
                mfp.types.push('image');
                _mfpOn(OPEN_EVENT + ns, function() {
                    if (mfp.currItem.type === 'image' && imgSt.cursor) $(document.body).addClass(imgSt.cursor);
                });
                _mfpOn(CLOSE_EVENT + ns, function() {
                    if (imgSt.cursor) $(document.body).removeClass(imgSt.cursor);
                    _window.off('resize' + EVENT_NS);
                });
                _mfpOn('Resize' + ns, mfp.resizeImage);
                if (mfp.isLowIE) _mfpOn('AfterChange', mfp.resizeImage);
            },
            resizeImage: function() {
                var item = mfp.currItem;
                if (!item || !item.img) return;
                if (mfp.st.image.verticalFit) {
                    var decr = 0;
                    // fix box-sizing in ie7/8
                    if (mfp.isLowIE) decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'), 10);
                    item.img.css('max-height', mfp.wH - decr);
                }
            },
            _onImageHasSize: function(item) {
                if (item.img) {
                    item.hasSize = true;
                    if (_imgInterval) clearInterval(_imgInterval);
                    item.isCheckingImgSize = false;
                    _mfpTrigger('ImageHasSize', item);
                    if (item.imgHidden) {
                        if (mfp.content) mfp.content.removeClass('mfp-loading');
                        item.imgHidden = false;
                    }
                }
            },
            /**
             * Function that loops until the image has size to display elements that rely on it asap
             */ findImageSize: function(item) {
                var counter = 0, img = item.img[0], mfpSetInterval = function(delay) {
                    if (_imgInterval) clearInterval(_imgInterval);
                    // decelerating interval that checks for size of an image
                    _imgInterval = setInterval(function() {
                        if (img.naturalWidth > 0) {
                            mfp._onImageHasSize(item);
                            return;
                        }
                        if (counter > 200) clearInterval(_imgInterval);
                        counter++;
                        if (counter === 3) mfpSetInterval(10);
                        else if (counter === 40) mfpSetInterval(50);
                        else if (counter === 100) mfpSetInterval(500);
                    }, delay);
                };
                mfpSetInterval(1);
            },
            getImage: function(item, template) {
                var guard = 0, // image load complete handler
                onLoadComplete = function() {
                    if (item) {
                        if (item.img[0].complete) {
                            item.img.off('.mfploader');
                            if (item === mfp.currItem) {
                                mfp._onImageHasSize(item);
                                mfp.updateStatus('ready');
                            }
                            item.hasSize = true;
                            item.loaded = true;
                            _mfpTrigger('ImageLoadComplete');
                        } else {
                            // if image complete check fails 200 times (20 sec), we assume that there was an error.
                            guard++;
                            if (guard < 200) setTimeout(onLoadComplete, 100);
                            else onLoadError();
                        }
                    }
                }, // image error handler
                onLoadError = function() {
                    if (item) {
                        item.img.off('.mfploader');
                        if (item === mfp.currItem) {
                            mfp._onImageHasSize(item);
                            mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src));
                        }
                        item.hasSize = true;
                        item.loaded = true;
                        item.loadError = true;
                    }
                }, imgSt = mfp.st.image;
                var el = template.find('.mfp-img');
                if (el.length) {
                    var img = document.createElement('img');
                    img.className = 'mfp-img';
                    if (item.el && item.el.find('img').length) img.alt = item.el.find('img').attr('alt');
                    item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
                    img.src = item.src;
                    // without clone() "error" event is not firing when IMG is replaced by new IMG
                    // TODO: find a way to avoid such cloning
                    if (el.is('img')) item.img = item.img.clone();
                    img = item.img[0];
                    if (img.naturalWidth > 0) item.hasSize = true;
                    else if (!img.width) item.hasSize = false;
                }
                mfp._parseMarkup(template, {
                    title: _getTitle(item),
                    img_replaceWith: item.img
                }, item);
                mfp.resizeImage();
                if (item.hasSize) {
                    if (_imgInterval) clearInterval(_imgInterval);
                    if (item.loadError) {
                        template.addClass('mfp-loading');
                        mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src));
                    } else {
                        template.removeClass('mfp-loading');
                        mfp.updateStatus('ready');
                    }
                    return template;
                }
                mfp.updateStatus('loading');
                item.loading = true;
                if (!item.hasSize) {
                    item.imgHidden = true;
                    template.addClass('mfp-loading');
                    mfp.findImageSize(item);
                }
                return template;
            }
        }
    });
    /*>>image*/ /*>>zoom*/ var hasMozTransform, getHasMozTransform = function() {
        if (hasMozTransform === undefined) hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
        return hasMozTransform;
    };
    $.magnificPopup.registerModule('zoom', {
        options: {
            enabled: false,
            easing: 'ease-in-out',
            duration: 300,
            opener: function(element) {
                return element.is('img') ? element : element.find('img');
            }
        },
        proto: {
            initZoom: function() {
                var zoomSt = mfp.st.zoom, ns = '.zoom', image;
                if (!zoomSt.enabled || !mfp.supportsTransition) return;
                var duration = zoomSt.duration, getElToAnimate = function(image) {
                    var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'), transition = 'all ' + zoomSt.duration / 1000 + 's ' + zoomSt.easing, cssObj = {
                        position: 'fixed',
                        zIndex: 9999,
                        left: 0,
                        top: 0,
                        '-webkit-backface-visibility': 'hidden'
                    }, t = 'transition';
                    cssObj['-webkit-' + t] = cssObj['-moz-' + t] = cssObj['-o-' + t] = cssObj[t] = transition;
                    newImg.css(cssObj);
                    return newImg;
                }, showMainContent = function() {
                    mfp.content.css('visibility', 'visible');
                }, openTimeout, animatedImg;
                _mfpOn('BuildControls' + ns, function() {
                    if (mfp._allowZoom()) {
                        clearTimeout(openTimeout);
                        mfp.content.css('visibility', 'hidden');
                        // Basically, all code below does is clones existing image, puts in on top of the current one and animated it
                        image = mfp._getItemToZoom();
                        if (!image) {
                            showMainContent();
                            return;
                        }
                        animatedImg = getElToAnimate(image);
                        animatedImg.css(mfp._getOffset());
                        mfp.wrap.append(animatedImg);
                        openTimeout = setTimeout(function() {
                            animatedImg.css(mfp._getOffset(true));
                            openTimeout = setTimeout(function() {
                                showMainContent();
                                setTimeout(function() {
                                    animatedImg.remove();
                                    image = animatedImg = null;
                                    _mfpTrigger('ZoomAnimationEnded');
                                }, 16); // avoid blink when switching images
                            }, duration); // this timeout equals animation duration
                        }, 16); // by adding this timeout we avoid short glitch at the beginning of animation
                    // Lots of timeouts...
                    }
                });
                _mfpOn(BEFORE_CLOSE_EVENT + ns, function() {
                    if (mfp._allowZoom()) {
                        clearTimeout(openTimeout);
                        mfp.st.removalDelay = duration;
                        if (!image) {
                            image = mfp._getItemToZoom();
                            if (!image) return;
                            animatedImg = getElToAnimate(image);
                        }
                        animatedImg.css(mfp._getOffset(true));
                        mfp.wrap.append(animatedImg);
                        mfp.content.css('visibility', 'hidden');
                        setTimeout(function() {
                            animatedImg.css(mfp._getOffset());
                        }, 16);
                    }
                });
                _mfpOn(CLOSE_EVENT + ns, function() {
                    if (mfp._allowZoom()) {
                        showMainContent();
                        if (animatedImg) animatedImg.remove();
                        image = null;
                    }
                });
            },
            _allowZoom: function() {
                return mfp.currItem.type === 'image';
            },
            _getItemToZoom: function() {
                if (mfp.currItem.hasSize) return mfp.currItem.img;
                else return false;
            },
            // Get element postion relative to viewport
            _getOffset: function(isLarge) {
                var el;
                if (isLarge) el = mfp.currItem.img;
                else el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
                var offset = el.offset();
                var paddingTop = parseInt(el.css('padding-top'), 10);
                var paddingBottom = parseInt(el.css('padding-bottom'), 10);
                offset.top -= $(window).scrollTop() - paddingTop;
                /*

                Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

                 */ var obj = {
                    width: el.width(),
                    // fix Zepto height+padding issue
                    height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
                };
                // I hate to do this, but there is no another option
                if (getHasMozTransform()) obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
                else {
                    obj.left = offset.left;
                    obj.top = offset.top;
                }
                return obj;
            }
        }
    });
    /*>>zoom*/ /*>>gallery*/ /**
     * Get looped index depending on number of slides
     */ var _getLoopedId = function(index) {
        var numSlides = mfp.items.length;
        if (index > numSlides - 1) return index - numSlides;
        else if (index < 0) return numSlides + index;
        return index;
    }, _replaceCurrTotal = function(text, curr, total) {
        return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
    };
    $.magnificPopup.registerModule('gallery', {
        options: {
            enabled: false,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [
                0,
                2
            ],
            navigateByImgClick: true,
            arrows: true,
            tPrev: 'Previous (Left arrow key)',
            tNext: 'Next (Right arrow key)',
            tCounter: '%curr% of %total%'
        },
        proto: {
            initGallery: function() {
                var gSt = mfp.st.gallery, ns = '.mfp-gallery';
                mfp.direction = true; // true - next, false - prev
                if (!gSt || !gSt.enabled) return false;
                _wrapClasses += ' mfp-gallery';
                _mfpOn(OPEN_EVENT + ns, function() {
                    if (gSt.navigateByImgClick) mfp.wrap.on('click' + ns, '.mfp-img', function() {
                        if (mfp.items.length > 1) {
                            mfp.next();
                            return false;
                        }
                    });
                    _document.on('keydown' + ns, function(e) {
                        if (e.keyCode === 37) mfp.prev();
                        else if (e.keyCode === 39) mfp.next();
                    });
                });
                _mfpOn('UpdateStatus' + ns, function(e, data) {
                    if (data.text) data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
                });
                _mfpOn(MARKUP_PARSE_EVENT + ns, function(e, element, values, item) {
                    var l = mfp.items.length;
                    values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
                });
                _mfpOn('BuildControls' + ns, function() {
                    if (mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
                        var markup = gSt.arrowMarkup, arrowLeft = mfp.arrowLeft = $(markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, 'left')).addClass(PREVENT_CLOSE_CLASS), arrowRight = mfp.arrowRight = $(markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, 'right')).addClass(PREVENT_CLOSE_CLASS);
                        arrowLeft.click(function() {
                            mfp.prev();
                        });
                        arrowRight.click(function() {
                            mfp.next();
                        });
                        mfp.container.append(arrowLeft.add(arrowRight));
                    }
                });
                _mfpOn(CHANGE_EVENT + ns, function() {
                    if (mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);
                    mfp._preloadTimeout = setTimeout(function() {
                        mfp.preloadNearbyImages();
                        mfp._preloadTimeout = null;
                    }, 16);
                });
                _mfpOn(CLOSE_EVENT + ns, function() {
                    _document.off(ns);
                    mfp.wrap.off('click' + ns);
                    mfp.arrowRight = mfp.arrowLeft = null;
                });
            },
            next: function() {
                mfp.direction = true;
                mfp.index = _getLoopedId(mfp.index + 1);
                mfp.updateItemHTML();
            },
            prev: function() {
                mfp.direction = false;
                mfp.index = _getLoopedId(mfp.index - 1);
                mfp.updateItemHTML();
            },
            goTo: function(newIndex) {
                mfp.direction = newIndex >= mfp.index;
                mfp.index = newIndex;
                mfp.updateItemHTML();
            },
            preloadNearbyImages: function() {
                var p = mfp.st.gallery.preload, preloadBefore = Math.min(p[0], mfp.items.length), preloadAfter = Math.min(p[1], mfp.items.length), i;
                for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++)mfp._preloadItem(mfp.index + i);
                for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++)mfp._preloadItem(mfp.index - i);
            },
            _preloadItem: function(index) {
                index = _getLoopedId(index);
                if (mfp.items[index].preloaded) return;
                var item = mfp.items[index];
                if (!item.parsed) item = mfp.parseEl(index);
                _mfpTrigger('LazyLoad', item);
                if (item.type === 'image') item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
                    item.hasSize = true;
                }).on('error.mfploader', function() {
                    item.hasSize = true;
                    item.loadError = true;
                    _mfpTrigger('LazyLoadError', item);
                }).attr('src', item.src);
                item.preloaded = true;
            }
        }
    });
    /*>>gallery*/ _checkInstance();
})(jQuery);



var $30e095f900a4f827$exports = {};
/* skel.js v3.0.2-dev | (c) skel.io | MIT licensed */ var $30e095f900a4f827$var$skel = function() {
    "use strict";
    var t = {
        breakpointIds: null,
        events: {},
        isInit: !1,
        obj: {
            attachments: {},
            breakpoints: {},
            head: null,
            states: {}
        },
        sd: "/",
        state: null,
        stateHandlers: {},
        stateId: "",
        vars: {},
        DOMReady: null,
        indexOf: null,
        isArray: null,
        iterate: null,
        matchesMedia: null,
        extend: function(e, n) {
            t.iterate(n, function(i) {
                t.isArray(n[i]) ? (t.isArray(e[i]) || (e[i] = []), t.extend(e[i], n[i])) : "object" == typeof n[i] ? ("object" != typeof e[i] && (e[i] = {}), t.extend(e[i], n[i])) : e[i] = n[i];
            });
        },
        newStyle: function(t) {
            var e = document.createElement("style");
            return e.type = "text/css", e.innerHTML = t, e;
        },
        _canUse: null,
        canUse: function(e) {
            t._canUse || (t._canUse = document.createElement("div"));
            var n = t._canUse.style, i = e.charAt(0).toUpperCase() + e.slice(1);
            return e in n || "Moz" + i in n || "Webkit" + i in n || "O" + i in n || "ms" + i in n;
        },
        on: function(e, n) {
            var i = e.split(/[\s]+/);
            return t.iterate(i, function(e) {
                var a = i[e];
                if (t.isInit) {
                    if ("init" == a) return void n();
                    if ("change" == a) n();
                    else {
                        var r = a.charAt(0);
                        if ("+" == r || "!" == r) {
                            var o = a.substring(1);
                            if (o in t.obj.breakpoints) {
                                if ("+" == r && t.obj.breakpoints[o].active) n();
                                else if ("!" == r && !t.obj.breakpoints[o].active) return void n();
                            }
                        }
                    }
                }
                t.events[a] || (t.events[a] = []), t.events[a].push(n);
            }), t;
        },
        trigger: function(e) {
            if (t.events[e] && 0 != t.events[e].length) return t.iterate(t.events[e], function(n) {
                t.events[e][n]();
            }), t;
        },
        breakpoint: function(e) {
            return t.obj.breakpoints[e];
        },
        breakpoints: function(e) {
            function n(t, e) {
                this.name = this.id = t, this.media = e, this.active = !1, this.wasActive = !1;
            }
            return n.prototype.matches = function() {
                return t.matchesMedia(this.media);
            }, n.prototype.sync = function() {
                this.wasActive = this.active, this.active = this.matches();
            }, t.iterate(e, function(i) {
                t.obj.breakpoints[i] = new n(i, e[i]);
            }), window.setTimeout(function() {
                t.poll();
            }, 0), t;
        },
        addStateHandler: function(e, n) {
            t.stateHandlers[e] = n;
        },
        callStateHandler: function(e) {
            var n = t.stateHandlers[e]();
            t.iterate(n, function(e) {
                t.state.attachments.push(n[e]);
            });
        },
        changeState: function(e) {
            t.iterate(t.obj.breakpoints, function(e) {
                t.obj.breakpoints[e].sync();
            }), t.vars.lastStateId = t.stateId, t.stateId = e, t.breakpointIds = t.stateId === t.sd ? [] : t.stateId.substring(1).split(t.sd), t.obj.states[t.stateId] ? t.state = t.obj.states[t.stateId] : (t.obj.states[t.stateId] = {
                attachments: []
            }, t.state = t.obj.states[t.stateId], t.iterate(t.stateHandlers, t.callStateHandler)), t.detachAll(t.state.attachments), t.attachAll(t.state.attachments), t.vars.stateId = t.stateId, t.vars.state = t.state, t.trigger("change"), t.iterate(t.obj.breakpoints, function(e) {
                t.obj.breakpoints[e].active ? t.obj.breakpoints[e].wasActive || t.trigger("+" + e) : t.obj.breakpoints[e].wasActive && t.trigger("-" + e);
            });
        },
        generateStateConfig: function(e, n) {
            var i = {};
            return t.extend(i, e), t.iterate(t.breakpointIds, function(e) {
                t.extend(i, n[t.breakpointIds[e]]);
            }), i;
        },
        getStateId: function() {
            var e = "";
            return t.iterate(t.obj.breakpoints, function(n) {
                var i = t.obj.breakpoints[n];
                i.matches() && (e += t.sd + i.id);
            }), e;
        },
        poll: function() {
            var e = "";
            e = t.getStateId(), "" === e && (e = t.sd), e !== t.stateId && t.changeState(e);
        },
        _attach: null,
        attach: function(e) {
            var n = t.obj.head, i = e.element;
            return (!i.parentNode || !i.parentNode.tagName) && (t._attach || (t._attach = n.firstChild), n.insertBefore(i, t._attach.nextSibling), e.permanent && (t._attach = i), !0);
        },
        attachAll: function(e) {
            var n = [];
            t.iterate(e, function(t) {
                n[e[t].priority] || (n[e[t].priority] = []), n[e[t].priority].push(e[t]);
            }), n.reverse(), t.iterate(n, function(e) {
                t.iterate(n[e], function(i) {
                    t.attach(n[e][i]);
                });
            });
        },
        detach: function(t) {
            var e = t.element;
            return !(t.permanent || !e.parentNode || e.parentNode && !e.parentNode.tagName) && (e.parentNode.removeChild(e), !0);
        },
        detachAll: function(e) {
            var n = {};
            t.iterate(e, function(t) {
                n[e[t].id] = !0;
            }), t.iterate(t.obj.attachments, function(e) {
                e in n || t.detach(t.obj.attachments[e]);
            });
        },
        attachment: function(e) {
            return e in t.obj.attachments ? t.obj.attachments[e] : null;
        },
        newAttachment: function(e, n, i, a) {
            return t.obj.attachments[e] = {
                id: e,
                element: n,
                priority: i,
                permanent: a
            };
        },
        init: function() {
            t.initMethods(), t.initVars(), t.initEvents(), t.obj.head = document.getElementsByTagName("head")[0], t.isInit = !0, t.trigger("init");
        },
        initEvents: function() {
            t.on("resize", function() {
                t.poll();
            }), t.on("orientationChange", function() {
                t.poll();
            }), t.DOMReady(function() {
                t.trigger("ready");
            }), window.onload && t.on("load", window.onload), window.onload = function() {
                t.trigger("load");
            }, window.onresize && t.on("resize", window.onresize), window.onresize = function() {
                t.trigger("resize");
            }, window.onorientationchange && t.on("orientationChange", window.onorientationchange), window.onorientationchange = function() {
                t.trigger("orientationChange");
            };
        },
        initMethods: function() {
            document.addEventListener ? !function(e, n) {
                t.DOMReady = n();
            }("domready", function() {
                function t(t) {
                    for(r = 1; t = n.shift();)t();
                }
                var e, n = [], i = document, a = "DOMContentLoaded", r = /^loaded|^c/.test(i.readyState);
                return i.addEventListener(a, e = function() {
                    i.removeEventListener(a, e), t();
                }), function(t) {
                    r ? t() : n.push(t);
                };
            }) : !function(e, n) {
                t.DOMReady = n();
            }("domready", function(t) {
                function e(t) {
                    for(h = 1; t = i.shift();)t();
                }
                var n, i = [], a = !1, r = document, o = r.documentElement, s = o.doScroll, c = "DOMContentLoaded", d = "addEventListener", u = "onreadystatechange", l = "readyState", f = s ? /^loaded|^c/ : /^loaded|c/, h = f.test(r[l]);
                return r[d] && r[d](c, n = function() {
                    r.removeEventListener(c, n, a), e();
                }, a), s && r.attachEvent(u, n = function() {
                    /^c/.test(r[l]) && (r.detachEvent(u, n), e());
                }), t = s ? function(e) {
                    self != top ? h ? e() : i.push(e) : function() {
                        try {
                            o.doScroll("left");
                        } catch (n) {
                            return setTimeout(function() {
                                t(e);
                            }, 50);
                        }
                        e();
                    }();
                } : function(t) {
                    h ? t() : i.push(t);
                };
            }), Array.prototype.indexOf ? t.indexOf = function(t, e) {
                return t.indexOf(e);
            } : t.indexOf = function(t, e) {
                if ("string" == typeof t) return t.indexOf(e);
                var n, i, a = e ? e : 0;
                if (!this) throw new TypeError;
                if (i = this.length, 0 === i || a >= i) return -1;
                for(a < 0 && (a = i - Math.abs(a)), n = a; n < i; n++)if (this[n] === t) return n;
                return -1;
            }, Array.isArray ? t.isArray = function(t) {
                return Array.isArray(t);
            } : t.isArray = function(t) {
                return "[object Array]" === Object.prototype.toString.call(t);
            }, Object.keys ? t.iterate = function(t, e) {
                if (!t) return [];
                var n, i = Object.keys(t);
                for(n = 0; i[n] && e(i[n], t[i[n]]) !== !1; n++);
            } : t.iterate = function(t, e) {
                if (!t) return [];
                var n;
                for(n in t)if (Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]) === !1) break;
            }, window.matchMedia ? t.matchesMedia = function(t) {
                return "" == t || window.matchMedia(t).matches;
            } : window.styleMedia || window.media ? t.matchesMedia = function(t) {
                if ("" == t) return !0;
                var e = window.styleMedia || window.media;
                return e.matchMedium(t || "all");
            } : window.getComputedStyle ? t.matchesMedia = function(t) {
                if ("" == t) return !0;
                var e = document.createElement("style"), n = document.getElementsByTagName("script")[0], i = null;
                e.type = "text/css", e.id = "matchmediajs-test", n.parentNode.insertBefore(e, n), i = "getComputedStyle" in window && window.getComputedStyle(e, null) || e.currentStyle;
                var a = "@media " + t + "{ #matchmediajs-test { width: 1px; } }";
                return e.styleSheet ? e.styleSheet.cssText = a : e.textContent = a, "1px" === i.width;
            } : t.matchesMedia = function(t) {
                if ("" == t) return !0;
                var e, n, i, a, r = {
                    "min-width": null,
                    "max-width": null
                }, o = !1;
                for(i = t.split(/\s+and\s+/), e = 0; e < i.length; e++)n = i[e], "(" == n.charAt(0) && (n = n.substring(1, n.length - 1), a = n.split(/:\s+/), 2 == a.length && (r[a[0].replace(/^\s+|\s+$/g, "")] = parseInt(a[1]), o = !0));
                if (!o) return !1;
                var s = document.documentElement.clientWidth, c = document.documentElement.clientHeight;
                return !(null !== r["min-width"] && s < r["min-width"] || null !== r["max-width"] && s > r["max-width"] || null !== r["min-height"] && c < r["min-height"] || null !== r["max-height"] && c > r["max-height"]);
            }, navigator.userAgent.match(/MSIE ([0-9]+)/) && RegExp.$1 < 9 && (t.newStyle = function(t) {
                var e = document.createElement("span");
                return e.innerHTML = '&nbsp;<style type="text/css">' + t + "</style>", e;
            });
        },
        initVars: function() {
            var e, n, i, a = navigator.userAgent;
            e = "other", n = 0, i = [
                [
                    "firefox",
                    /Firefox\/([0-9\.]+)/
                ],
                [
                    "bb",
                    /BlackBerry.+Version\/([0-9\.]+)/
                ],
                [
                    "bb",
                    /BB[0-9]+.+Version\/([0-9\.]+)/
                ],
                [
                    "opera",
                    /OPR\/([0-9\.]+)/
                ],
                [
                    "opera",
                    /Opera\/([0-9\.]+)/
                ],
                [
                    "edge",
                    /Edge\/([0-9\.]+)/
                ],
                [
                    "safari",
                    /Version\/([0-9\.]+).+Safari/
                ],
                [
                    "chrome",
                    /Chrome\/([0-9\.]+)/
                ],
                [
                    "ie",
                    /MSIE ([0-9]+)/
                ],
                [
                    "ie",
                    /Trident\/.+rv:([0-9]+)/
                ]
            ], t.iterate(i, function(t, i) {
                if (a.match(i[1])) return e = i[0], n = parseFloat(RegExp.$1), !1;
            }), t.vars.browser = e, t.vars.browserVersion = n, e = "other", n = 0, i = [
                [
                    "ios",
                    /([0-9_]+) like Mac OS X/,
                    function(t) {
                        return t.replace("_", ".").replace("_", "");
                    }
                ],
                [
                    "ios",
                    /CPU like Mac OS X/,
                    function(t) {
                        return 0;
                    }
                ],
                [
                    "wp",
                    /Windows Phone ([0-9\.]+)/,
                    null
                ],
                [
                    "android",
                    /Android ([0-9\.]+)/,
                    null
                ],
                [
                    "mac",
                    /Macintosh.+Mac OS X ([0-9_]+)/,
                    function(t) {
                        return t.replace("_", ".").replace("_", "");
                    }
                ],
                [
                    "windows",
                    /Windows NT ([0-9\.]+)/,
                    null
                ],
                [
                    "bb",
                    /BlackBerry.+Version\/([0-9\.]+)/,
                    null
                ],
                [
                    "bb",
                    /BB[0-9]+.+Version\/([0-9\.]+)/,
                    null
                ]
            ], t.iterate(i, function(t, i) {
                if (a.match(i[1])) return e = i[0], n = parseFloat(i[2] ? i[2](RegExp.$1) : RegExp.$1), !1;
            }), t.vars.os = e, t.vars.osVersion = n, t.vars.IEVersion = "ie" == t.vars.browser ? t.vars.browserVersion : 99, t.vars.touch = "wp" == t.vars.os ? navigator.msMaxTouchPoints > 0 : !!("ontouchstart" in window), t.vars.mobile = "wp" == t.vars.os || "android" == t.vars.os || "ios" == t.vars.os || "bb" == t.vars.os;
        }
    };
    return t.init(), t;
}();
!function(t, e) {
    "function" == typeof define && define.amd ? define([], e) : $30e095f900a4f827$exports = e();
}($30e095f900a4f827$exports, function() {
    return $30e095f900a4f827$var$skel;
});


const $54b47fc030b7b21e$var$settings = {
    banner: {
        // Indicators (= the clickable dots at the bottom).
        indicators: false,
        // Transition speed (in ms)
        // For timing purposes only. It *must* match the transition speed of "#banner > article".
        speed: 1500,
        // Transition delay (in ms)
        delay: 5000,
        // Parallax intensity (between 0 and 1; higher = more intense, lower = less intense; 0 = off)
        parallax: 0.25
    }
};




(function($) {
    $30e095f900a4f827$exports.breakpoints({
        xlarge: '(max-width: 1680px)',
        large: '(max-width: 1280px)',
        medium: '(max-width: 980px)',
        small: '(max-width: 736px)',
        xsmall: '(max-width: 480px)'
    });
    /**
     * Applies parallax scrolling to an element's background image.
     * @return {jQuery} jQuery object.
     */ $.fn._parallax = $30e095f900a4f827$exports.vars.browser === 'ie' || $30e095f900a4f827$exports.vars.mobile ? function() {
        return $(this);
    } : function(intensity) {
        const $window = $(window), $this = $(this);
        if (this.length === 0 || intensity === 0) return $this;
        if (this.length > 1) {
            for(let i = 0; i < this.length; i++)$(this[i])._parallax(intensity);
            return $this;
        }
        if (!intensity) intensity = 0.25;
        $this.each(function() {
            const $t = $(this);
            const on = ()=>{
                $t.css('background-position', 'center 100%, center 100%, center 0px');
                $window.on('scroll._parallax', function() {
                    const pos = $window.scrollTop() - $t.position().top;
                    $t.css('background-position', 'center ' + pos * (-1 * intensity) + 'px');
                });
            };
            const off = ()=>{
                $t.css('background-position', '');
                $window.off('scroll._parallax');
            };
            $30e095f900a4f827$exports.on('change', ()=>{
                if ($30e095f900a4f827$exports.breakpoint('medium').active) off();
                else on();
            });
        });
        $window.off('load._parallax resize._parallax').on('load._parallax resize._parallax', function() {
            $window.trigger('scroll');
        });
        return $(this);
    };
    /**
     * Custom banner slider for Slate.
     * @return {jQuery} jQuery object.
     */ $.fn._slider = function(options) {
        const $this = $(this);
        if (this.length === 0) return $this;
        if (this.length > 1) {
            for(let i = 0; i < this.length; i++)$(this[i])._slider(options);
            return $this;
        }
        // Vars.
        let current = 0, pos = 0, lastPos = 0, slides = [], indicators = [], $indicators, $slides = $this.children('article'), intervalId, isLocked = false, i = 0;
        // Turn off indicators if we only have one slide.
        if ($slides.length === 1) options.indicators = false;
        // Functions.
        $this._switchTo = function(x, stop) {
            if (isLocked || pos === x) return;
            isLocked = true;
            if (stop) window.clearInterval(intervalId);
            // Update positions.
            lastPos = pos;
            pos = x;
            // Hide last slide.
            slides[lastPos].removeClass('top');
            if (options.indicators) indicators[lastPos].removeClass('visible');
            // Show new slide.
            slides[pos].addClass('visible').addClass('top');
            if (options.indicators) indicators[pos].addClass('visible');
            // Finish hiding last slide after a short delay.
            window.setTimeout(function() {
                slides[lastPos].addClass('instant').removeClass('visible');
                window.setTimeout(function() {
                    slides[lastPos].removeClass('instant');
                    isLocked = false;
                }, 100);
            }, options.speed);
        };
        // Indicators.
        if (options.indicators) $indicators = $('<ul class="indicators"></ul>').appendTo($this);
        // Slides.
        $slides.each(function() {
            const $slide = $(this), $img = $slide.find('img');
            // Slide.
            $slide.css('background-image', 'url("' + $img.attr('src') + '")').css('background-position', $slide.data('position') ? $slide.data('position') : 'center');
            // Add to slides.
            slides.push($slide);
            // Indicators.
            if (options.indicators) {
                const $indicator_li = $('<li>' + i + '</li>').appendTo($indicators);
                // Indicator.
                $indicator_li.data('index', i).on('click', function() {
                    $this._switchTo($(this).data('index'), true);
                });
                // Add to indicators.
                indicators.push($indicator_li);
            }
            i++;
        })._parallax(options.parallax);
        // Initial slide.
        slides[pos].addClass('visible').addClass('top');
        if (options.indicators) indicators[pos].addClass('visible');
        // Bail if we only have a single slide.
        if (slides.length === 1) return;
        // Main loop.
        intervalId = window.setInterval(function() {
            current++;
            if (current >= slides.length) current = 0;
            $this._switchTo(current);
        }, options.delay);
    };
    $(document).ready(function() {
        const $window = $(window), $body = $('body'), $header = $('#header'), $banner = $('.banner');
        // Disable animations/transitions until the page has loaded.
        $body.addClass('is-loading');
        $window.on('load', function() {
            window.setTimeout(function() {
                $body.removeClass('is-loading');
            }, 100);
        });
        // Prioritize "important" elements on medium.
        $30e095f900a4f827$exports.on('+medium -medium', function() {
            $.prioritize('.important\\28 medium\\29', $30e095f900a4f827$exports.breakpoint('medium').active);
        });
        // Banner.
        $banner._slider($54b47fc030b7b21e$var$settings.banner);
        // Menu.
        // $('#menu')
        //     .append('<a href="#menu" class="close"></a>')
        //     .appendTo($body)
        //     .panel({
        //         delay: 500,
        //         hideOnClick: true,
        //         hideOnSwipe: true,
        //         resetScroll: true,
        //         resetForms: true,
        //         side: 'right'
        //     });
        // Header.
        if ($30e095f900a4f827$exports.vars.IEVersion < 9) $header.removeClass('alt');
        if ($banner.length > 0 && $header.hasClass('alt')) {
            $window.on('resize', function() {
                $window.trigger('scroll');
            });
            $banner.scrollex({
                bottom: $header.outerHeight(),
                terminate: function() {
                    $header.removeClass('alt');
                },
                enter: function() {
                    $header.addClass('alt');
                },
                leave: function() {
                    $header.removeClass('alt');
                    $header.addClass('reveal');
                }
            });
        }
        $('.furniture-gallery').magnificPopup({
            items: [
                {
                    src: {}
                },
                {
                    src: {}
                },
                {
                    src: {}
                },
                {
                    src: {}
                }
            ],
            gallery: {
                enabled: true
            },
            type: 'image' // this is default type
        });
    });
})(jQuery);


//# sourceMappingURL=home.a6c64f58.js.map
